import React from 'react';
import dayjs from 'dayjs';
import { When } from 'packages/when/when';
import { SummaryLabelledInfo } from '../labelled-info';
// eslint-disable-next-line max-len
import { useSelectSubmissionInformation } from '../../../../../admin/buy-process/buy-order-edit/components/submission-information/submission-information-utils';
import { LinkLoading } from '../../../../../../packages/link-loading/link-loading';
import { StaffUtils } from '../../../../../../utils/staff';
// eslint-disable-next-line max-len
import { useSubmissionInformationFiles } from '../../../../../admin/buy-process/buy-order-edit/components/submission-information/use-submission-information';

interface SummarySubmissionInformationProps {
  orderId: string;
}

export const SummarySubmissionInformation = ({
  orderId,
}: SummarySubmissionInformationProps) => {
  const {
    registrationDate,
    invoiceNumber,
    internalDealDate,
    organizationNumber,
    organizationName,
    internalManager,
  } = useSelectSubmissionInformation(orderId);

  const { registerData, regEvidence, memorandum } = useSubmissionInformationFiles(orderId);

  const formatDate = (date?: string): string => {
    if (!date) return '';

    return dayjs(date).format('D. MMMM YYYY');
  };

  return (
    <React.Fragment>
      <SummaryLabelledInfo label="Affärsdatum">
        {formatDate(internalDealDate)}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Fakturanummer">
        {invoiceNumber}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Handläggare: Namn">
        {internalManager && (
          <React.Fragment>
            {StaffUtils.getUser(internalManager.userId)?.firstName}{' '}
            {StaffUtils.getUser(internalManager.userId)?.lastName}
          </React.Fragment>
        )}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Tilldelat lagerbolag: Namn">
        {organizationName}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Tilldelat lagerbolag: OrgNr">
        {organizationNumber}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Tilldelat lagerbolag: Registreringsdatum">
        {formatDate(registrationDate)}
      </SummaryLabelledInfo>
      <When condition={regEvidence.isInitiallyPresent}>
        <SummaryLabelledInfo label="Tilldelat lagerbolag: Reg.Bevis">
          <LinkLoading
            isLoading={regEvidence.isLoading}
            onClick={regEvidence.open}
          >
            Registreringbevis
          </LinkLoading>
        </SummaryLabelledInfo>
      </When>
      <When condition={memorandum.isInitiallyPresent}>
        <SummaryLabelledInfo label="Tilldelat lagerbolag: Stiftelseurkund">
          <LinkLoading
            isLoading={memorandum.isLoading}
            onClick={memorandum.open}
          >
            Stiftelseurkund
          </LinkLoading>
        </SummaryLabelledInfo>
      </When>
      <When condition={registerData.isInitiallyPresent}>
        <SummaryLabelledInfo label="Färdigregistrerad ändring: Registeruppgift">
          <LinkLoading
            isLoading={registerData.isLoading}
            onClick={registerData.open}
          >
            Registeruppgift
          </LinkLoading>
        </SummaryLabelledInfo>
      </When>
    </React.Fragment>
  );
};
